import { DemoDefinition } from "../DemoDefinition";
import { DemoRegistry } from "../DemoRegistry";
import { AutogenLayoutDemoScreenFlowSample } from "./autogen/AutogenLayoutDemoScreenFlowSample";

export class DemoScreenFlowSample extends AutogenLayoutDemoScreenFlowSample {
}
DemoRegistry.get().register(new DemoDefinition("dialogs/DemoScreenFlowSample", [ "Concepts", "Screen Flow Sample" ]));
